<template>
    <div class="ResumePreview" v-if="isshow">
        <!--个人信息-->
        <div class="personal_info_box">
            <div class="info_left_div">
                <img :src="resumeData.baseinfo.customericonurl?resumeData.baseinfo.customericonurl:
                (resumeData.baseinfo.sex=='男'?require('@/common/images/talentsimg/default_user.png'):require('@/common/images/talentsimg/default_user2.png'))" alt="">
                <div v-if="resumeData.baseinfo.name === '' || !resumeData.baseinfo.name" class="info_div">
                    <p>未填写</p>
                    <div>
                        <img :src="require('@/common/images/talentsimg/bicon1.png')" alt="">
                        <span>未填写</span>
                    </div>
                    <div>
                        <img :src="require('@/common/images/talentsimg/bicon2.png')" alt="">
                        <span>未填写</span>
                    </div>
                    <div class="contact_info_div">
                        <img :src="require('@/common/images/talentsimg/bicon3.png')" alt="">
                        <span>未填写</span>
                        <img :src="require('@/common/images/talentsimg/bicon4.png')" alt="">
                        <span>未填写</span>
                    </div>
                </div>
                <div v-else class="info_div">
                    <p>{{resumeData.baseinfo.name}}</p>
                    <div>
                        <img :src="require('@/common/images/talentsimg/bicon1.png')" alt="">
                        <span>{{resumeData.baseinfo.sex}}</span>
                        <span>{{resumeData.baseinfo.birth}}</span>
                        <span>{{resumeData.baseinfo.nativeplace}}</span>
                        <span>{{resumeData.baseinfo.edutype}}</span>
                    </div>
                    <div>
                        <img :src="require('@/common/images/talentsimg/bicon2.png')" alt="">
                        <span>{{resumeData.baseinfo.exptype}}</span>
                        <span>{{resumeData.baseinfo.jobstatus}}</span>
                        <span>目前年薪{{resumeData.baseinfo.currentsalary}}万</span>
                    </div>
                </div>
            </div>
        </div>
        <!--求职意向-->
        <div class="resume_item_box">
            <div class="title_box">
                <div class="title_left_box">
                    <img :src="require('@/common/images/talentsimg/cicon1.png')" alt="">
                    <span>求职意向</span>
                </div>
            </div>
            <div class="Job_Intension_info_box">
                <div class="Job_Intension_row_div">
                    <label>期望行业：</label>
                    <span>{{resumeData.baseinfo.wishindustry}}</span>
                </div>
                <div class="Job_Intension_row_div">
                    <label>期望职位：</label>
                    <span>{{resumeData.baseinfo.wishjobname}}</span>
                </div>
                <div class="Job_Intension_row_div">
                    <label>期望地点：</label>
                    <span>{{resumeData.baseinfo.wishplace}}</span>
                </div>
                <div class="Job_Intension_row_div">
                    <label>期望年薪：</label>
                    <span v-if="resumeData.baseinfo.wishsalary === 0 && resumeData.baseinfo.wishsalarymax === 0 && resumeData.baseinfo.wishindustry !== ''">面议</span>
                    <span v-if="resumeData.baseinfo.wishsalary !== 0 || resumeData.baseinfo.wishsalarymax !== 0">{{resumeData.baseinfo.wishsalary}}-{{resumeData.baseinfo.wishsalarymax}}万/年</span>
                    <span v-if="resumeData.baseinfo.wishindustry === ''"></span>
                </div>
            </div>
        </div>
        <!--工作经历-->
        <div class="resume_item_box">
            <div class="title_box">
                <div class="title_left_box">
                    <img :src="require('@/common/images/talentsimg/cicon2.png')" alt="">
                    <span>工作经历</span>
                </div>
            </div>
            <div class="occupational_history_box"  v-if="resumeData.companyinfolist.length>0">
                <div class="occupational_history_item_box" v-for="(item, index) in resumeData.companyinfolist" :key="index">
                    <div class="content_div">
                        <div class="handle_box occupational_history_item_row_div">
                            <div class="time_info">{{item.jobbegin}}-{{item.istoday ? '至今' : item.jobend}}</div>
                        </div>
                        <div class="company_name_text occupational_history_item_row_div">{{item.companyname}}</div>
                        <div class="job_info_div occupational_history_item_row_div">
                            <span>{{item.industryname}}</span>
                            <span>{{item.jobname}}</span>
                        </div>
                        <div class="job_desc_div occupational_history_item_row_div">{{item.jobinfo}}</div>
                    </div>
                </div>
            </div>
            <div class="occupational_history_box" v-else>未填写</div>
        </div>
        <!--项目经历-->
        <div class="resume_item_box">
            <div class="title_box">
                <div class="title_left_box">
                    <img :src="require('@/common/images/talentsimg/cicon3.png')" alt="">
                    <span>项目经历</span>
                </div>
            </div>
            <div class="Project_experience_box" v-if="resumeData.projectinfolist.length>0">
                <div class="Project_experience_item_box" v-for="(item, index) in resumeData.projectinfolist" :key="index">
                    <div class="content_div">
                        <div class="company_name_text Project_experience_item_row_div">{{item.projectname}}</div>
                        <div class="Project_experience_item_row_div">{{item.dutyname}}</div>
                        <div class="Project_desc_row_div Project_experience_item_row_div">
                            <p>项目职责：</p>
                            <p class="p_desc_text">{{item.projectduty}}</p>
                        </div>
                        <div v-if="item.projectexpinfo !== ''" class="Project_desc_row_div Project_experience_item_row_div">
                            <p>项目业绩：</p>
                            <p class="p_desc_text">{{item.projectexpinfo}}</p>
                        </div>
                        <div class="Project_desc_row_div Project_experience_item_row_div">
                            <p>项目描述：</p>
                            <p class="p_desc_text2">{{item.projectinfo}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Project_experience_box" v-else>未填写</div>
        </div>
        <!--教育经历-->
        <div class="resume_item_box">
            <div class="title_box">
                <div class="title_left_box">
                    <img :src="require('@/common/images/talentsimg/cicon4.png')" alt="">
                    <span>教育经历</span>
                </div>
            </div>
            <div class="edu_experience_box" v-if="resumeData.eduinfolist.length>0">
                <div class="edu_experience_item_box" v-for="(item, index) in resumeData.eduinfolist" :key="index">
                    <div class="content_div">
                        <div class="edu_time edu_row_div">{{item.edubegin}}-{{item.istoday ? '至今' : item.eduend}}</div>
                        <div class="school_name edu_row_div">{{item.eduname}}</div>
                        <div class="profession_name edu_row_div">{{item.majorname}}</div>
                        <div class="education_background edu_row_div">{{item.edulevel}}</div>
                    </div>
                </div>
            </div>
            <div class="edu_experience_box" v-else>未填写</div>
        </div>
        <!--自我评价-->
        <div class="resume_item_box">
            <div class="title_box">
                <div class="title_left_box">
                    <img :src="require('@/common/images/talentsimg/cicon5.png')" alt="">
                    <span>自我评价</span>
                </div>
            </div>
            <div class="self_evaluation_box">{{resumeData.baseinfo.selfevaluation}}</div>
        </div>
    </div>
</template>

<script>
    import {getResumeDetail} from 'api/talentApi'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'ResumePreview',
        data() {
            return {
                isshow:false,
                resumeData: {
                    baseinfo: {}, // 基本信息
                    companyinfolist:[], // 工作经历
                    projectinfolist: [], // 项目经历
                    eduinfolist: [] // 教育经历
                },
            }
        },
        created() {
            if(this.domainInfo.isMobile){
                this.$router.push({
                    name: 'MResumePreview',
                    query: {'innerid': this.$route.query.innerid}
                })
            }
        },
        mounted() {
            this.findResumeAllInfo()
        },
        methods: {
            findResumeAllInfo() {
                this.setLoading(true)
                let params = {
                    innerid:this.$route.query.innerid?this.$route.query.innerid:''
                }
                getResumeDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        this.resumeData = data.data
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['domainInfo'])
        },
        components: {

        }
    }
</script>

<style lang="scss" type="text/scss">
    .ResumePreview {
        width: 1200px;
        margin: 20px auto 20px;
        padding: 40px;
        background: #fff;
        .personal_info_box {
            display: flex;
            justify-content: space-between;
            .info_left_div {
                padding-top: 10px;
                display: flex;
                align-items: center;
                &>img {
                    width: 120px;
                    height: 120px;
                    margin-right: 30px;
                    border-radius: 60px;
                }
                .info_div {
                    &>p {
                        color: #333;
                        font-size: 20px;
                        line-height:28px;
                        font-weight: bold;
                    }
                    &>div {
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        &>img {
                            width: 16px;
                            height: 16px;
                            margin-right: 10px;
                        }
                        &>span {
                            color: #666;
                            font-size: 14px;
                            line-height: 20px;
                        }
                        span+span {
                            margin-left: 15px;
                        }
                    }
                    .contact_info_div {
                        &>span {
                            min-width: 105px;
                        }
                    }
                }
            }
        }
        .resume_item_box {
            margin-top: 40px;
            .title_box {
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
                .title_left_box {
                    display: flex;
                    align-items: center;
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 6px;
                    }
                    span {
                        color: #333;
                        font-size: 18px;
                        line-height:26px;
                        font-weight: bold;
                    }
                }
                .title_right_box {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 8px;
                    }
                    span {
                        color: #2E7FFF;
                        line-height:20px;
                    }
                }
                .gray_style {
                    span {
                        color: #999;
                    }
                }
            }
            .Job_Intension_info_box {
                .Job_Intension_row_div {
                    line-height: 20px;
                    label {
                        color: #999;
                    }
                    span {
                        color: #666;
                    }
                }
                .Job_Intension_row_div + .Job_Intension_row_div {
                    margin-top: 10px;
                }
            }
            .occupational_history_box, .Project_experience_box {
                .occupational_history_item_box, .Project_experience_item_box {
                    .content_div {
                        box-sizing: border-box;
                        padding: 20px 10px;
                        line-height: 20px;
                    }
                    .handle_box {
                        display: flex;
                        justify-content: space-between;
                        .time_info {
                            line-height: 20px;
                        }
                        .handle_div {
                            display: none;
                            &>div {
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                margin-left: 20px;
                                img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 6px;
                                }
                                span {
                                    color: #2E7FFF;
                                }
                            }
                            &>div + &>div {
                                margin-left: 20px;
                            }
                        }
                        .gray_div {
                            &>div {
                                span {
                                    color: #999;
                                }
                            }
                        }
                    }
                    .company_name_text {
                        font-weight: bold;
                        line-height: 20px;
                    }
                    .job_info_div {
                        line-height: 20px;
                        span {
                            color: #999;
                        }
                        span + span {
                            margin-left: 15px;
                        }
                    }
                    .job_desc_div {
                        line-height: 24px;
                        color: #666;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        line-clamp: 3;
                        -webkit-box-orient: vertical;
                    }
                    .Project_desc_row_div {
                        display: flex;
                        p:nth-of-type(1) {
                            white-space: nowrap;
                            color: #999;
                        }
                        .p_desc_text {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        .p_desc_text2 {
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                    .occupational_history_item_row_div + .occupational_history_item_row_div {
                        margin-top: 10px;
                    }
                    .Project_experience_item_row_div + .Project_experience_item_row_div {
                        margin-top: 10px;
                    }
                }
                .occupational_history_item_box + .occupational_history_item_box {
                    border-top: 1px solid #e5e5e5;
                }
                .Project_experience_item_box + .Project_experience_item_box {
                    border-top: 1px solid #e5e5e5;
                }
            }
            .edu_experience_box {
                .edu_experience_item_box {
                    .content_div {
                        height: 60px;
                        display: flex;
                        .edu_row_div + .edu_row_div {
                            margin-left: 35px;
                        }
                        .edu_time {
                            line-height: 60px;
                            width: 150px;
                        }
                        .school_name, .profession_name {
                            line-height: 60px;
                            width: 240px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        .profession_name {
                            width: 130px;
                        }
                        .education_background {
                            line-height: 60px;
                            margin-right: 100px;
                        }
                        .handle_div {
                            display: none;
                            &>div {
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                margin-left: 20px;
                                img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 6px;
                                }
                                span {
                                    color: #2E7FFF;
                                }
                            }
                            &>div + &>div {
                                margin-left: 20px;
                            }
                        }
                        .gray_div {
                            &>div {
                                span {
                                    color: #999;
                                }
                            }
                        }
                    }
                }
                /*.edu_experience_item_box:hover {*/
                    /*.content_div {*/
                        /*border: 1px solid #2E7FFF!important;*/
                        /*.handle_div {*/
                            /*display: flex;*/
                        /*}*/
                    /*}*/
                /*}*/
                .edu_experience_item_box + .edu_experience_item_box {
                    border-top: 1px solid #e5e5e5;
                }
            }
            .self_evaluation_box {
                line-height:24px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }
        .resume_item_box:nth-of-type(1) {
            margin-top: 50px;
        }
    }
</style>